<template>
  <div class="main-wrapper">
    <p>
      <span
        :class="
          !(agreement[0] || agreement[1]) ? 'unvalid-field' : 'valid-field'
        "
        >➤</span
      >
      Наличие договорных отношений с другими кредитными организациями, в том
      числе расторгнутых
    </p>
    <label>
      <input
        type="checkbox"
        v-model="agreement[0]"
        @click="
          agreement[1] = false;
          clearRows();
        "
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('HAS_ANOTHER_BANKS') != -1
        "
      />ДА
    </label>
    <label>
      <input
        type="checkbox"
        v-model="agreement[1]"
        @click="
          agreement[0] = false;
          rows = [];
        "
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('HAS_ANOTHER_BANKS') != -1
        "
      />НЕТ
    </label>
    <p class="necessary-table-not" v-if="agreement[0] && !checkRows()">
      Заполните хотя бы одну строку таблицы.
    </p>
    <table v-if="agreement[0]">
      <tr>
        <td width="3%"></td>
        <td width="10%" class="necessary-bold">
          БИК банка,
          <br />СВИФТ банка нерезидента
        </td>
        <td width="24%" class="necessary-bold">Наименование банка</td>
        <td width="15%" class="necessary-bold">Характер отношений</td>
        <td width="15%" class="necessary-bold">Год начала отношений</td>
        <td width="24%" class="necessary-bold">Год окончания отношений</td>
      </tr>
      <tr v-for="item in rows" :key="item.id" class="input_rows">
        <td>
          <span :class="checkRow(item) ? 'valid-field' : 'unvalid-field'"
            >➤</span
          >
        </td>
        <td>
          <input
            type="text"
            v-model="item.BIK"
            v-mask="'###########'"
            @blur="controlRows(item)"
          />
        </td>
        <td>
          <input
            type="text"
            v-model="item.name"
            :disabled="item.gettingInfo"
            :onchanged="
              item.name != null && item.name.length > 80
                ? (item.name = item.name.substr(0, 80))
                : item.name
            "
          />
        </td>
        <td>
          <dropdown
            style="width: 200px"
            :options="relationshipType"
            :selected="{ name: item.type }"
            placeholder="Характер отношений"
            v-on:updateOption="enterRelationshipType(item, $event.name)"
          ></dropdown>
        </td>
        <td>
          <input
            type="text"
            v-model="item.startDate"
            v-mask="'####'"
            @input="
              item.startDate != checkDate(item.startDate)
                ? (item.startDate = checkDate(item.startDate))
                : item.startDate
            "
          />
        </td>
        <td>
          <input
            type="text"
            v-model="item.endDate"
            :disabled="item.noEnd"
            v-mask="'####'"
            @input="
              item.endDate != checkDate(item.endDate)
                ? (item.endDate = checkDate(item.endDate))
                : item.endDate
            "
          />
          <label>
            <input
              type="checkbox"
              v-model="item.noEnd"
              @click="onClickCheck(item)"
            />по настоящее время
          </label>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import mask from "./utils/my-mask.js";
import dropdown from "vue-dropdowns";

export default {
  name: "ListOfAnotherBanks",
  components: {
    dropdown,
  },
  props: {
    pageInfo: {},
    pageName: String,
    currentBankBik: String,
    bankName: String,
    url: String,
  },
  data() {
    return {
      rows: [],
      agreement: [false, false],
      sendData: { PREV_BANKS: [] },
      relationshipType: [],
    };
  },
  methods: {
    controlRows(row) {
      if (row.BIK.length >= 8 && row.BIK.length <= 11) {
        if (row.BIK == this.currentBankBik) {
          this.$alert("Введен БИК " + this.bankName);
          row.BIK = "";
        } else if (this.isBankAlreadyWrite(row)) {
          this.$alert("Данный БИК уже существует");
          row.BIK = "";
        } else {
          this.getBankName(row);
        }
      }
      if (this.rows[this.rows.length - 1].BIK.length >= 8) {
        this.rows.push({
          id: this.rows.length,
          BIK: "",
          name: "",
          startDate: "",
          endDate: "",
          gettingInfo: false,
          noEnd: false,
        });
        this.rows[this.rows.length - 1].id = this.rows.length;
      }
    },
    enterRelationshipType(item, name) {
      item.type = name;
      this.$forceUpdate();
    },
    clearRows() {
      this.rows = [
        {
          id: 0,
          BIK: "",
          name: "",
          startDate: "",
          endDate: "",
          gettingInfo: false,
          noEnd: false,
        },
      ];
    },
    checkDate(date) {
      return mask.dateYearOnly(date);
    },
    onClickCheck(item) {
      item.endDate = "";
    },
    async getBankName(row) {
      row.gettingInfo = true;
      try {
        let data = await (
          await fetch(this.url + "get_bank_by_bik", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({ INN: this.pageInfo.INN, BIK: row.BIK }),
          })
        ).json();
        if (data.BIK != null) row.name = data.BIK;
      } catch (e) {
        console.log(e);
      }
      row.gettingInfo = false;
    },
    isBankAlreadyWrite(row) {
      let exist = false;
      this.rows.forEach((item) => {
        if (item.BIK == row.BIK && item.id != row.id) exist = true;
      });
      return exist;
    },
    validation() {
      var msg = "";

      if (!(this.agreement[0] || this.agreement[1]))
        msg +=
          "• Укажите наличие договорных отношений с другими кредитными организациями<br>";
      if (this.agreement[0] && !this.checkRows())
        msg += "• Заполните хотя бы одну строку таблицы";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.createSendData();
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
    checkRow(item) {
      return (
        item.BIK.length >= 8 &&
        item.BIK.length <= 11 &&
        item.name.length > 0 &&
        item.type != null &&
        item.type.length > 0 &&
        parseInt(item.startDate) >= 1900 &&
        parseInt(item.startDate) <= new Date().getFullYear() &&
        (item.noEnd || parseInt(item.endDate) >= parseInt(item.startDate))
      );
    },
    checkRows() {
      let a = false;
      this.rows.forEach((item) => {
        a = a || this.checkRow(item);
      });
      return a;
    },
    createSendData() {
      this.sendData.HAS_ANOTHER_BANKS = this.agreement[0];
      this.sendData.PREV_BANKS = [];
      this.rows.forEach((item) => {
        if (
          item.BIK.length >= 8 &&
          item.type != null &&
          item.type.length > 0 &&
          (item.endDate.length == 4 || item.noEnd) &&
          item.startDate.length == 4 &&
          item.name.length > 0
        ) {
          var a = {
            PREV_BANK_BIK: item.BIK,
            PREV_BANK_NAME: item.name,
            PREV_FROM_YEAR: item.startDate,
            PREV_BANK_DESCRIPTION: item.type,
          };
          if (!item.noEnd) a.PREV_TO_YEAR = item.endDate;
          this.sendData.PREV_BANKS.push(a);
        }
      });
    },
    fillRows(data) {
      if (data != null && data.length > 0)
        data.forEach((item) => {
          this.agreement = [true, false];
          this.rows.push({
            id: this.rows.length,
            BIK: item.PREV_BANK_BIK,
            name: item.PREV_BANK_NAME,
            type: item.PREV_BANK_DESCRIPTION,
            startDate: item.PREV_FROM_YEAR,
            noEnd: item.PREV_TO_YEAR == null,
            endDate: item.PREV_TO_YEAR == null ? "" : item.PREV_TO_YEAR,
            gettingInfo: false,
          });
        });
      this.rows.push({
        id: this.rows.length,
        BIK: "",
        name: "",
        startDate: "",
        endDate: "",
        gettingInfo: false,
        noEnd: false,
      });
    },
  },
  async created() {
    this.sendData.INN = this.pageInfo.INN;

    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    if (this.pageInfo.HAS_ANOTHER_BANKS != null)
      this.agreement = [
        this.pageInfo.HAS_ANOTHER_BANKS,
        !this.pageInfo.HAS_ANOTHER_BANKS,
      ];
    if (this.pageInfo.RELATIONSHIP_TYPES == null)
      this.pageInfo.RELATIONSHIP_TYPES = [
        "расчетно-кассовое обслуживание",
        "депозитные операции",
        "кредитование",
        "сопровождение внешнеэкономической деятельности",
        "документарные операции (аккредитивы, инкассо)",
        "банковские гарантии",
        "депозитарное обслуживание",
        "брокерское обслуживание",
        "банковская корпоративная карта",
        "зарплатный проект",
        "торговый эквайринг",
        "инкассация",
        "аренда индивидуальных сейфов",
        "клиент-банк",
        "операции с монетами и драгоценными металлами",
        "иные операции",
      ];
    this.pageInfo.RELATIONSHIP_TYPES.forEach((el) =>
      this.relationshipType.push({ name: el })
    );
    this.fillRows(this.pageInfo.PREV_BANKS);
    this.validation();
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
  beforeDestroy() {
    this.$emit("sendToServer", this.pageName, this.sendData);
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: left;
}

table {
  text-align: center;
  border-collapse: collapse;
  border: 1px solid grey;
  width: 100%;
  margin-top: 10px;
}
td {
  border: 1px solid grey;
  padding: 5px 10px;
}
input[type="text"] {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 100%;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.necessary {
  color: red;
}
</style>
